// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"jgp-3lV2c","button":"jgp-2ObA2","icon":"jgp-29aIk"};